import React, { useEffect, useRef, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Grid, Typography, Card, Paper } from '@mui/material'

import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function CycleTimer(props) {

    const karmaContext = useKarmaPoolContext();

    const [cycleNumber, setCycleNumber] = useState(() => {
        return 1;
    });

    const [cycleRefreshed, setCycleRefreshed] = useState(() => {
        return false;
    });

    const [cycleEndTime, setCycleEndTime] = useState(0);

    function useInterval(callback, delay) {
        const savedCallback = useRef();

        // Remember the latest callback.
        useEffect(() => {
            savedCallback.current = callback;
        }, [callback]);

        // Set up the interval.
        useEffect(() => {
            function tick() {
                savedCallback.current();
            }
            if (delay !== null) {
                let id = setInterval(tick, delay);
                return () => clearInterval(id);
            }
        }, [delay]);
    }

    useInterval(() => {
        updateCycleTimeLeft();
    }, 1000);

    useEffect(() => {
        updateCycleTimeLeft();
    }, []);

    useEffect(() => {
        setCycleNumber(karmaContext.local.cycle["cycleNumber"]);
        setCycleRefreshed(false);
    }, [karmaContext.local.cycle])

    // convert cycle number like 1 or 2 into format 001 or 002
    function formatCycleNumber(cycleNumber) {
        if (cycleNumber < 10) {
            return "00" + cycleNumber;
        } else if (cycleNumber < 100) {
            return "0" + cycleNumber;
        } else {
            return cycleNumber;
        }
    }

    function updateCycleTimeLeft() {
        console.log("setCycleEndTime useEffect")

        // endDateTime: "2023-02-11T10:25:29.177987"
        let endTime = karmaContext.local.cycle["endDateTime"];

        // get getTime of now using London time
        let now = new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/London"}));

        // timeLeft till endTime in hours with 2dp
        let timeLeft = new Date(endTime).getTime() - now.getTime();
        timeLeft = timeLeft / 1000 / 60 / 60;

        // timeLeft now formatted to be a string 2 days, 10 hours, 30 minutes, 10 seconds
        let days = Math.floor(timeLeft / 24);
        let hours = Math.floor(timeLeft % 24);
        let minutes = Math.floor((timeLeft * 60) % 60);
        let seconds = Math.floor((timeLeft * 60 * 60) % 60);

        if (!cycleRefreshed && (days < 0 || hours < 0 || minutes < 0 || seconds < 0)) {
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;

            console.log("cycle ended at time " + karmaContext.local.cycle.endDateTime);

            karmaContext.refresh();

            setCycleRefreshed(true);
        }

        timeLeft = days + "d, " + hours + "h, " + minutes + "m, " + seconds + "s";

        setCycleEndTime(timeLeft);
    }

    function Variant1() {
        return (
            <>
                Cycle <strong>#{formatCycleNumber(cycleNumber)}</strong> ends in
                <Box sx={{ marginTop: "0.5rem" }} />
                {cycleEndTime}
            </>
        );
    }

    function Variant2() {
        return (
            <>
                {cycleEndTime} left to decide
            </>
        );
    }

    return (
        <>
            <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.0em", color: "whitesmoke" }}>
                {props.variant === 2 ? Variant2() : Variant1()}
            </Typography>
        </>
    );
}

export default CycleTimer;


